import './style.scss';
import 'swiper/swiper.scss';
import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

export function specialists_slider_block() {

    const blocks = document.querySelectorAll('.specialists_slider_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {

        const swiperContainer = block.querySelector('.specialists-swiper');
        const swiperWrapper = block.querySelector('.swiper-wrapper');
        if (!swiperContainer) return;

        const nextBtn = block.querySelector('.swiper-button-next');
        const prevBtn = block.querySelector('.swiper-button-prev');

        const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;

        const hideNav = () => {
            if (nextBtn) nextBtn.style.display = "none";
            if (prevBtn) prevBtn.style.display = "none";
        };

        const w = window.innerWidth;


        if (w >= 1440 && slideCount <= 4) {
            hideNav();
        } else if (w >= 992 && w < 1440 && slideCount <= 3) {
            hideNav();
        } else if (w >= 768 && w < 992 && slideCount <= 2) {
            hideNav();
        } else if (w < 768 && slideCount <= 1) {
            hideNav();
        }



        if (slideCount === 6 || slideCount === 7) {
            swiperWrapper.classList.add('limited-slides');
        }

        new Swiper(swiperContainer, {
            slidesPerView: 1.53,
            spaceBetween: 24,
            speed: 600,
            centeredSlides: slideCount > 7,
            loop: slideCount > 5,
            slidesOffsetAfter: slideCount <= 5 ? 20 : 0,
            slidesOffsetBefore: slideCount <= 5 ? 20 : 0,




            breakpoints: {
                768: { slidesPerView: 2.31 },
                992: {
                    slidesPerView: 3.05,
                },
                1280: {
                    slidesPerView: 3.8,
                    slidesOffsetAfter: slideCount === 6 || slideCount === 7 ? -206 : 0,
                },
                1440: {
                    slidesPerView: 4.26,
                    slidesOffsetAfter: slideCount === 6 || slideCount === 7 ? -127 : 0,
                },
                1920: { slidesPerView: 4.27 },
            },

            modules: [Navigation],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
        });

    });
}
